
export default {
  name: 'AsyncModal',
  data() {
    return {
      isOpen: false,
      title: '',
      titleClass: 'b-r-sm font-333',
      message: '',
      messageClass: 'b-r-sm font-777',
      confirmBtnText: '확인',
      cancelBtnText: '',
      // Private variables
      resolvePromise: undefined,
      rejectPromise: undefined,
      // confirm과 alert의 동작이 다름
      closeModal: () => {},
    };
  },
  computed: {
    hasBodySlot: ({ $slots }) => !!$slots.body,
  },
  methods: {
    showConfirm(opts = {}) {
      this.title = opts.title || '';
      this.titleClass = opts.titleClass || this.titleClass;
      this.message = opts.message || '';
      this.messageClass = opts.messageClass || this.messageClass;
      if (opts.confirmBtnText) this.confirmBtnText = opts.confirmBtnText;
      this.cancelBtnText = opts.cancelBtnText || '';
      this.isOpen = true;

      this.closeModal = () => {
        this.isOpen = false;
        this.resolvePromise(false);
      };

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    showAlert(opts = {}) {
      this.title = opts.title || '';
      this.titleClass = opts.titleClass || this.titleClass;
      this.message = opts.message || '';
      this.messageClass = opts.messageClass || this.messageClass;
      if (opts.confirmBtnText) this.confirmBtnText = opts.confirmBtnText;
      this.cancelBtnText = '';
      this.isOpen = true;

      this.closeModal = () => {
        this.isOpen = false;
        this.resolvePromise(false);
      };

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    _confirm() {
      this.isOpen = false;
      this.resolvePromise(true);
    },
    _cancel() {
      this.isOpen = false;
      this.resolvePromise(false);
    },
  },
};
